<template>
  <section>
    <el-row style="min-width:1200px;padding:15px">
      <el-row :gutter="10">
        <el-button icon="el-icon-arrow-left" circle @click="$router.push({path:'/mainData/index'})"></el-button>

        <el-radio-group
          v-model="getWhich"
          @change="changeGet"
          class="rgroup"
          style="margin-left:60px"
        >
          <el-radio-button label="原生广告" class="radio"></el-radio-button>
          <el-radio-button label="买量详情" class="radio"></el-radio-button>
          <el-radio-button label="分发详情" class="radio"></el-radio-button>
        </el-radio-group>
        
  
          <!--<searchApp
            compare="pid"
            @getid="res=>{chooseProduct.product_id=res}"
            :pholder="chooseProduct.product_id"
            sstyle="width:260px"
          ></searchApp>-->
          <!-- <searchApp
            @getid="res=>{chooseProduct.product_id=res}"
            compare="pid"
            sstyle="width:260px"
            :pholder="chooseProduct.name"
          ></searchApp>-->
            <el-select v-model="chooseProduct.name" filterable placeholder="请输入小程序名称">
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct(item)"
					      default-first-option
					    ></el-option>
					  </el-select>
   
        
        

        <div style="float:right">
          <el-select v-model="type" placeholder="请选择" @change="changeGet">
            <el-option label="请选择" value="-1"></el-option>
            <el-option label="矩阵" value="1"></el-option>
            <el-option label="非矩阵" value="0"></el-option>
          </el-select>
          <el-button type="primary" plain @click="changeDate(1)">昨天</el-button>
          <el-button type="primary" plain @click="changeDate(7)">最近7天</el-button>
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            :start-placeholder="pdata.sdate"
            :end-placeholder="pdata.edate"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </el-row>
    </el-row>
    <!-- <el-row>
      <el-radio-group v-model="getWhich" @change="changeGet">
        <el-radio-button label="原生广告"></el-radio-button>
        <el-radio-button label="买量详情"></el-radio-button>
      </el-radio-group>
    </el-row>-->
    <!--列表-->
    <el-table
      :data="cdata.list"
      height="600" 
      style="width: 100%;min-width:1200px;margin-top:30px"
      stripe
      row-key="id"
      v-show="getWhich=='原生广告'"
    >
      <el-table-column prop="d_date" label="日期" align="center"></el-table-column>
      <el-table-column prop="origin_visit_pv" label="展示数" align="center"></el-table-column>
      <el-table-column prop="origin_click_pv" label="点击数" align="center"></el-table-column>
      <el-table-column prop="origin_income" label="原生收入" align="center"></el-table-column>
      <el-table-column prop="origin_click_per" label="单次点击收益" align="center"></el-table-column>
      <el-table-column prop="video_visit_pv" label="视频广告展示数" align="center"></el-table-column>
      <el-table-column prop="video_click_pv" label="视频广告点击数" align="center"></el-table-column>
      <el-table-column prop="video_income" label="视频收入" align="center"></el-table-column>
      <el-table-column prop="video_click_per" label="点击率" align="center"></el-table-column>
      <el-table-column prop="video_click_per" label="单次点击收益" align="center"></el-table-column>
    </el-table>

    <el-table
      :data="bdata.list"
       height="600"
      style="width: 100%;min-width:1200px;margin-top:30px"
      stripe
      row-key="id"
      v-show="getWhich=='买量详情'"
    >
      <el-table-column prop="issued_app_name" label="买量产品" align="center" fixed></el-table-column>
      <el-table-column prop="d_date" label="买量日期" align="center" min-width="100" fixed></el-table-column>
      <el-table-column label="买量金额" align="center" fixed>
        <template slot-scope="s">
          <el-button type="text" @click="updateBM(s.row.id,s.$index,s.row)">{{s.row.expenses_cost}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="buy_user" label="买量用户" align="center" fixed>
        <template slot-scope="s">
          <el-button type="text" @click="updateBM(s.row.id,s.$index,s.row)">{{s.row.buy_user}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="roi" label="回收预测" align="center" fixed></el-table-column>
      <el-table-column prop="day_0" label="当天回本" align="center"></el-table-column>
      <el-table-column v-for="i in 30" :key="i" :prop="'day_'+i" :label="i+'天回本'" align="center"></el-table-column>
    </el-table>

    <el-table
      :data="mdata.list"
       height="800"
      style="width: 100%;min-width:1200px;margin-top:30px"
      stripe
      row-key="id"
      v-show="getWhich=='分发详情'"
    >
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="issued" label="是否矩阵" align="center">
        <template slot-scope="scope">{{scope.row.issued==1?"矩阵":"非矩阵"}}</template>
      </el-table-column>
      <el-table-column prop="click_pv" label="点击次数" align="center"></el-table-column>
      <el-table-column prop="click_uv" label="点击人数" align="center"></el-table-column>
      <el-table-column prop="clickok_uv" label="点击成功人数" align="center">
        <template slot-scope="scope">{{scope.row.clickok_uv||0}}</template>
      </el-table-column>
      <el-table-column prop="income" label="收入预估" align="center">
        <!-- <template slot-scope="scope">{{scope.row.expenses_cost/expenses_visit_uv_new||0}}</template> -->
      </el-table-column>
    </el-table>
    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->

    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新买量数据" :visible.sync="updateBuyMoney" width="500px">
      <el-form :model="updateGroup">
        <el-form-item label="买量金额" prop="expenses_cost" class="inline">
          <el-input
            autofocus
            v-model="updateGroup.expenses_cost"
            placeholder="买量金额"
            class="input"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="买量用户" prop="buy_user" class="inline">
          <el-input v-model="updateGroup.buy_user" placeholder="买量用户" class="input" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateBuyMoney = false">取 消</el-button>
        <el-button type="primary" @click="sUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getDetailData,
  getMoreDetail,
  buyDetail,
  updateBuy,
  getIssuedAppList,
} from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      type: "-1",
      getWhich: "原生广告",
      chartColumn: null,
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
           sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
           edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
//      sdate: "",
//      edate: ""
      },
      IssAppList:[],
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      mdata: {},
      bdata: {},
      updateBuyMoney: false,
      updateIndex: "",
      updateGroup: { index_id: "", expenses_cost: "", buy_user: "" },
      chooseProduct:{name:"",id:''},
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
        	debugger;
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          if (this.getWhich == "原生广告") {
          	this.$route.params.sdate=this.pdata.sdate;
          	this.$route.params.edate=this.pdata.edate;
            this.getList();
          } else {
            this.changeGet();
          }
        }
        console.log(11111111111);
      },
      deep: true
    }
  },
  methods: {
  	changeProduct(res){
  		 this.$route.params.issued_app_id=res.id;
  	 	 this.pdata.issued_app_id=res.id;
  	 	 this.getList();
  	 	 
  	 },
  	getIssAPPList(){
  		var p="";
  		getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.IssAppList = res.data;
          this.IssAppList.forEach((v,i)=>{
          	if(v.id==this.pdata.issued_app_id ){
          		this.chooseProduct.name=v.name;
          	}
          })
        }
      });
  	},
    getList() {
      var p = "";
//    if(!this.pdata.sdate){
//    	this.pdata.sdate=
//    }
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getDetailData(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.cdata = res.data;
        }
      });
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    changeGet() {
      var p =
        "issued_app_id=" +
        this.pdata.issued_app_id +
        "&sdate=" +
        this.pdata.sdate +
        "&edate=" +
        this.pdata.edate;
      if (this.getWhich == "分发详情") {
        p += "&issued=" + this.type;
        getMoreDetail(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            // this.cdata = res.data;
            // console.log(res);
            this.mdata = res.data;
          }
        });
      } else if (this.getWhich == "买量详情") {
        buyDetail(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            console.log(res);
            this.bdata = res.data;
          }
        });
      }
    },
    updateBM(id, index,s) {
      this.updateBuyMoney = true;
      this.updateIndex = index;
      this.updateGroup.index_id = id;
      this.updateGroup.expenses_cost = s.expenses_cost;
      this.updateGroup.buy_user = s.buy_user;
    },
    sUpdate() {
      var p = this.updateGroup;
      updateBuy(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.bdata.list[
            this.updateIndex
          ].expenses_cost = this.updateGroup.expenses_cost;
          this.bdata.list[
            this.updateIndex
          ].buy_user = this.updateGroup.buy_user;

          this.updateBuyMoney = false;
          this.updateGroup = { index_id: "", expenses_cost: "", buy_user: "" };
          this.updateIndex = "";
        }
      });
    }
  },

  mounted() {
    // this.getConfig();
    this.pdata.issued_app_id = this.$route.params.issued_app_id;
    if(this.$route.query.sdate!=undefined){
    	 this.pdata.sdate=this.$route.query.sdate;
    }
    if(this.$route.query.edate!=undefined){
    	this.pdata.edate=this.$route.query.edate;
    }
    if(this.$route.query.getWhich!=undefined){
    	this.getWhich=this.$route.query.getWhich;
    	 this.changeGet();
    }
    
//  debugger;
////  this.pdata.sdate=this.$route.sdate;
////  this.pdata.edate=this.$route.edate;
//		
//  this.dateVal = [this.$route.query.sdate,this.$route.query.edate];
    this.getIssAPPList();
    this.getList();
  },
  created(){
  	console.log('created')
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>
<style scoped>
.total {
  font-size: 20px;
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
}
</style>





// WEBPACK FOOTER //
// totalDetail.vue?7c72d2aa